namespace advisorop.services {
    `use strict`;

    /**
     * We will use this service for data and functionalities 
     * sharing between different dashboards for investor
     * 
     * THINK ABOUT: maybe it would be better to have different services for each dashboard
     */
    export class InvestorDashboardService {
        static $inject = [`$http`, `investorService`, `householdApi`, `generalService`];
        constructor(private $http: ng.IHttpService,
            private investorService: services.InvestorService,
            private hhApi: services.HouseholdApi,
            private generalService: services.GeneralService) {
        }
        
        /**
        * Empty chart data for Asset Allocation component/chart
        */
        getEmptyChartData = (): Array<domains.IChartDataSource> => {
            return [{
                chart: {
                    caption: "...", numberPrefix: "", subCaption: "", theme: ""
                },
                data: [],
                categories: [],
                dataset: []
            }];
        };

        /** 
         *  Call proper getHDCharts API based on provided "level"
         */
        getHdChartPromise = (level: string, householdId: number, groupType: number, groupId: number, accountId: number,
            sleeveId: number, showClosedInactive?: boolean, loadHistData: boolean = false, histChartDateType: domains.HistChartDateType = domains.HistChartDateType.LAST_SIX_MONTHS): ng.IHttpPromise<domains.IChartsDataSource> => {

            if (level == "H") {
                return this.hhApi.getCharts(householdId, groupType, level, null, null, null, showClosedInactive, null, loadHistData, histChartDateType);
            } else if (level == "R") {
                return this.hhApi.getCharts(householdId, groupType, level, groupId, null, null, showClosedInactive, null, loadHistData, histChartDateType);
            } else if (level == "A") {
                return this.hhApi.getCharts(householdId, groupType, level, groupId, accountId, null, showClosedInactive, null, loadHistData, histChartDateType);
            } else if (level == "S") {
                return this.hhApi.getCharts(householdId, groupType, level, groupId, accountId, sleeveId, showClosedInactive, null, loadHistData, histChartDateType);
            }

            return null;
        };

        /**
        * Calculate PpLevel and PpClientId based on account data
        */
        //calculatePpLevelAndClientId = (level: string, boRtgId: string, boCustodialAccountNumber: string,
        //    boUMAAccountIdentifierString: string): { pplevel: string, ppclientid: string } => {

        //    let noData = false;

        //    const ppData = {
        //        pplevel: null,
        //        ppclientid: null
        //    };

        //    if (level == "H") {
        //        // WE DONT SYNC OUR HH WITH PP
        //        noData = true;
        //    } else if (level == "R") {
        //        // AdvisorOp RTG level is PP household level
        //        if (boRtgId) {
        //            ppData.pplevel = "HH";
        //            ppData.ppclientid = boRtgId;
        //        } else {
        //            noData = true;
        //        }
        //    }
        //    else if (level == "A") {
        //        // AdvisorOp account level can be PP account or PP client group level
        //        // Checking first char of boUMAAccountIdentifierString is a hack to identify Folio accounts
        //        // We need to provide custodian from the server query and check that here instead.
        //        if (boUMAAccountIdentifierString && boUMAAccountIdentifierString.charAt(0) != 'R') {
        //            ppData.pplevel = "CG";
        //            ppData.ppclientid = "U-" + boUMAAccountIdentifierString;
        //        } else if (boCustodialAccountNumber) {
        //            ppData.pplevel = "AC";
        //            ppData.ppclientid = boCustodialAccountNumber;
        //        } else {
        //            noData = true;
        //        }
        //    }
        //    else if (level == "S") {
        //        // AdvisorOp sleeve level is PP account level
        //        if (boCustodialAccountNumber) {
        //            ppData.pplevel = "AC";
        //            ppData.ppclientid = boCustodialAccountNumber;
        //        } else {
        //            noData = true;
        //        }
        //    }

        //    if (noData) {
        //        // toastr.warning("There is no available back office data for this selection.");
        //        return null;
        //    }

        //    return ppData;
        //}

        calculatePpLevelAndClientId = (level: string, boRtgId: string, boCustodialAccountNumber: string,
            boUMAAccountIdentifierString: string): { pplevel: string, ppclientid: string } => {

            let noData = false;

            const ppData = {
                pplevel: null,
                ppclientid: null
            };

            if (level == "H") {
                // WE DONT SYNC OUR HH WITH PP
                noData = true;
            } else if (level == "R") {
                // AdvisorOp RTG level is PP household level
                if (boRtgId) {
                    ppData.pplevel = "HH";
                    ppData.ppclientid = boRtgId;
                } else {
                    noData = true;
                }
            }
            else if (level == "A") {
                // AdvisorOp account level can be PP account or PP client group level
                // Checking first char of boUMAAccountIdentifierString is a hack to identify Folio accounts
                // We need to provide custodian from the server query and check that here instead.
                if (boUMAAccountIdentifierString && boUMAAccountIdentifierString.charAt(0) != 'R') {
                    ppData.pplevel = "CG";
                    ppData.ppclientid = "U-" + boUMAAccountIdentifierString;
                } else if (boCustodialAccountNumber) {
                    ppData.pplevel = "AC";
                    ppData.ppclientid = boCustodialAccountNumber;
                } else {
                    noData = true;
                }
            }
            else if (level == "S") {
                // AdvisorOp sleeve level is PP account level
                if (boCustodialAccountNumber) {
                    ppData.pplevel = "AC";
                    ppData.ppclientid = boCustodialAccountNumber;
                } else {
                    noData = true;
                }
            }

            if (noData) {
                // toastr.warning("There is no available back office data for this selection.");
                return null;
            }

            return ppData;
        }

    }
    angular.module(Constants.ADVOP_SERVICES).service(`investorDashboardService`, InvestorDashboardService);
}